/**
 * Collection 页搜索：直接按产品标题过滤当前列表，不请求 search API
 */

/** @param {string} value */
const normalize = (value) => value.toLowerCase().trim();

/**
 * @param {string} title
 * @param {string} query
 */
const titleMatchesQuery = (title, query) => {
  const normalizedTitle = normalize(title);
  const normalizedQuery = normalize(query);

  if (!normalizedQuery) return true;

  return normalizedTitle.includes(normalizedQuery);
};

const getPage = () => document.querySelector('.nmkj-collection-page');

const getGrid = () => getPage()?.querySelector('.product-grid');

const getProductItems = () => {
  const grid = getGrid();
  if (!grid) return [];

  return [...grid.querySelectorAll('.product-grid__item[data-product-title]')];
};

const getQueryFromInputs = () => {
  const input = document.querySelector('.nmkj-collection-search-form input[name="q"]');
  return input instanceof HTMLInputElement ? input.value.trim() : '';
};

/** @param {string} query */
const syncSearchInputs = (query) => {
  for (const input of document.querySelectorAll('.nmkj-collection-search-form input[name="q"]')) {
    if (input instanceof HTMLInputElement) {
      input.value = query;
    }
  }
};

const getEmptyState = () => {
  const page = getPage();
  if (!page) return null;

  let empty = page.querySelector('.nmkj-collection-search-empty');

  if (!empty) {
    empty = document.createElement('div');
    empty.className = 'nmkj-collection-search-empty main-collection-grid__empty';
    empty.hidden = true;
    empty.innerHTML = `
      <h2 class="main-collection-grid__empty-title h2">No products found</h2>
      <p class="nmkj-collection-search-empty__message"></p>
    `;
    getGrid()?.insertAdjacentElement('afterend', empty);
  }

  return empty;
};

/** @param {number} visibleCount @param {string} query */
const updateResultsCount = (visibleCount, query) => {
  const countEl = getPage()?.querySelector('.nmkj-collection-toolbar__count');
  if (!(countEl instanceof HTMLElement)) return;

  if (!query) {
    const start = countEl.dataset.nmkjResultStart || '0';
    const end = countEl.dataset.nmkjResultEnd || '0';
    const total = countEl.dataset.nmkjTotalItems || '0';
    countEl.textContent = `${start}\u2013${end} of ${total} pieces`;
    return;
  }

  if (visibleCount === 0) {
    countEl.textContent = '0 pieces';
    return;
  }

  countEl.textContent = `1\u2013${visibleCount} of ${visibleCount} pieces`;
};

/** @param {string} query */
const applyTitleFilter = (query) => {
  const items = getProductItems();
  const grid = getGrid();
  const empty = getEmptyState();
  let visibleCount = 0;

  for (const item of items) {
    if (!(item instanceof HTMLElement)) continue;

    const title = item.dataset.productTitle ?? '';
    const isMatch = titleMatchesQuery(title, query);

    item.hidden = !isMatch;
    if (isMatch) visibleCount += 1;
  }

  if (grid instanceof HTMLElement) {
    grid.hidden = visibleCount === 0 && query.length > 0;
  }

  if (empty instanceof HTMLElement) {
    if (query && visibleCount === 0) {
      const message = empty.querySelector('.nmkj-collection-search-empty__message');
      if (message) {
        message.textContent = `No products with a matching title for "${query}".`;
      }
      empty.hidden = false;
    } else {
      empty.hidden = true;
    }
  }

  updateResultsCount(visibleCount, query);

  const pagination = getPage()?.querySelector('.pagination, [ref="pagination"]');
  if (pagination instanceof HTMLElement) {
    pagination.hidden = Boolean(query);
  }
};

/** @param {string} query */
const updateDisplayUrl = (query) => {
  const url = new URL(window.location.href);

  if (query) {
    url.searchParams.set('q', query);
  } else {
    url.searchParams.delete('q');
  }

  history.replaceState('', '', url.toString());
};

const handleSearchSubmit = (event) => {
  const form = event.target.closest('.nmkj-collection-search-form');
  if (!form) return;

  event.preventDefault();

  const query = new FormData(form).get('q')?.toString().trim() ?? '';
  syncSearchInputs(query);
  updateDisplayUrl(query);
  applyTitleFilter(query);
};

const handlePopState = () => {
  const query = new URLSearchParams(window.location.search).get('q')?.trim() ?? '';
  syncSearchInputs(query);
  applyTitleFilter(query);
};

const initFromUrl = () => {
  const query = new URLSearchParams(window.location.search).get('q')?.trim() ?? '';
  syncSearchInputs(query);
  if (query) applyTitleFilter(query);
};

document.addEventListener('submit', handleSearchSubmit);
window.addEventListener('popstate', handlePopState);

document.addEventListener('filter:update', () => {
  window.requestAnimationFrame(() => {
    initFromUrl();
  });
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFromUrl, { once: true });
} else {
  initFromUrl();
}
